import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {NGXLogger} from 'ngx-logger';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {AuthService} from '../tinea-components/okta/auth/auth.service';
import {StationGnvPagedList} from '../../swagger-gen/gnvert-secured/models';
import {GraphTagGroupList, GraphTagList, GraphTagSearch, StationPagedList} from '../../swagger-gen/web-secured/models';
import {ShivaWebSecuredConfiguration} from '../../swagger-gen/web-secured/shiva-web-secured-configuration';
import {BaseService} from '../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class StationsRepo extends BaseService {
  baseUrl = environment.apiUrl;
  basePublicUrl = environment.publicApiUrl;
  stationUrl = this.baseUrl + '/stations';
  customStationUrl = this.baseUrl + '/custom/stations';
  customStationsPublicUrl = this.basePublicUrl + '/custom/public';
  networkUrl = this.baseUrl + '/networks';
  stationConnectvity = this.baseUrl + '/stations-connectivity';
  // TODO: waiting for API from APIM
  readonly geoGouvApi = 'https://api-adresse.data.gouv.fr/search';
  readonly STATION_LIMIT = '200';

  constructor(
    public http: HttpClient,
    private logger: NGXLogger,
    private authService: AuthService,
    protected config: ShivaWebSecuredConfiguration
  ) {
    super();
  }

  getStationsList(
    offset?: number,
    limit?: number,
    params?: any[],
  ): Observable<StationPagedList> {
    const url = this.stationUrl + '/search';
    let requestParams: HttpParams;
    let requestString = this.pagination(offset as number, limit as number, this.STATION_LIMIT);
    let queryParams = '';
    if (params) {
      params.forEach((p: any) => {
        queryParams += '&' + p.key + '=' + p.value;
      });
    }
    requestString += queryParams;
    requestParams = new HttpParams({ fromString: requestString });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: requestParams,
    };
    return this.http.post<StationPagedList>(url, {}, httpOptions).pipe(
      tap((response) => {
        // this.logger.log(`Get stations List from backend`, response);
      }), // DEBUG
      catchError(this.handleServerError)
    );
  }

  getStationsListCustom(
    offset?: number,
    limit?: number,
    params?: any[],
  ): Observable<StationGnvPagedList> {
    const url = this.customStationUrl + '/search';
    let requestParams: any;
    let requestString = this.pagination(offset as number, limit as number, this.STATION_LIMIT);
    let queryParams = '';
    if (params) {
      params.forEach((p: any) => {
        queryParams += '&' + p.key + '=' + p.value;
      });
    }
    requestString += queryParams;
    requestParams = new HttpParams({ fromString: requestString });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: requestParams,
    };

    return this.http.post<StationGnvPagedList>(url, {}, httpOptions).pipe(
      tap((response) => {
        // this.logger.log(`Get stations List from backend`, response);
      }), // DEBUG
      catchError(this.handleServerError)
    );
  }

  /**
   * Get Station Tags for Graph purpose
   * @param uid - station uid
   * @param offset
   * @param limit
   * @param params
   * @param body
   */
  getStationTagsByGroup(
    uid: string,
    offset: number,
    limit: number,
    params: any[],
    body: GraphTagSearch
  ): Observable<GraphTagList> {
    const url = `${this.stationUrl}/${uid}/graph/tags/group/search`;
    let requestString = this.pagination(offset, limit, this.STATION_LIMIT);
    let queryParams = '';
    if (params) {
      params.forEach((p: any) => {
        queryParams += '&' + p.key + '=' + p.value;
      });
    }
    requestString += queryParams;
    const requestParams = new HttpParams({ fromString: requestString });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: requestParams,
    };
    const bodyReq = body ? body : { filters: [] };
    return this.http.post<GraphTagList>(url, bodyReq, httpOptions)
      .pipe(catchError(this.handleServerError));
  }

  /**
   * Get Station Grouped Tags for Graph purpose
   * @param uid - station uid
   * @param offset
   * @param limit
   * @param params
   * @param body
   */
  getStationGroupedTags(
    uid: string,
    offset: number,
    limit: number,
    params: any[],
    body: GraphTagSearch
  ): Observable<GraphTagGroupList> {
    const url = `${this.stationUrl}/${uid}/graph/tags/group`;
    let requestParams: any;
    let requestString = this.pagination(offset, limit, this.STATION_LIMIT);
    let queryParams = '';
    if (params) {
      params.forEach((p: any) => {
        queryParams += '&' + p.key + '=' + p.value;
      });
    }
    requestString += queryParams;
    requestParams = new HttpParams({ fromString: requestString });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: requestParams,
    };
    const bodyReq = body ? body : { filters: [] };
    return this.http.post<GraphTagGroupList>(url, bodyReq, httpOptions)
      .pipe(catchError(this.handleServerError));
  }
}
